import { CommonSchemaIds } from './common.const.js';
import { AuthenticationSchemaIds, AuthenticationTags } from "./authentication.const.js";
export const AUTHENTICATION_TLMD_SCHEMAS = {
    [AuthenticationSchemaIds.AUTHENTICATION]: {
        id: AuthenticationSchemaIds.AUTHENTICATION,
        schema: {
            unevaluatedProperties: false,
        },
        properties: {
            email: {
                ref: CommonSchemaIds.EMAIL,
                required: true,
                usage: [{ tag: AuthenticationTags.DEFAULT, input: { update: 1 } }]
            },
            secret: {
                ref: CommonSchemaIds.SECRET,
                required: true,
                usage: [{ tag: AuthenticationTags.DEFAULT, input: { update: 1 } }]
            },
        }
    },
    [AuthenticationSchemaIds.UPDATE_SECRET]: {
        id: AuthenticationSchemaIds.UPDATE_SECRET,
        schema: {
            unevaluatedProperties: false,
        },
        properties: {
            secret: {
                ref: CommonSchemaIds.SECRET,
                required: true,
                usage: [{ tag: AuthenticationTags.DEFAULT, input: { update: 1 } }]
            },
            newSecret: {
                ref: CommonSchemaIds.SECRET,
                required: true,
                usage: [{ tag: AuthenticationTags.DEFAULT, input: { update: 2 } }]
            },
        }
    },
    [AuthenticationSchemaIds.EMAIL]: {
        id: AuthenticationSchemaIds.EMAIL,
        schema: {
            unevaluatedProperties: false,
        },
        properties: {
            email: {
                ref: CommonSchemaIds.EMAIL,
                required: true,
                usage: [
                    { tag: AuthenticationTags.UPDATE_EMAIL, input: { update: 1 } },
                    { tag: AuthenticationTags.RESET_SECRET, input: { update: 1 } },
                    { tag: AuthenticationTags.RESET_VALIDATION, input: { update: 1 } },
                ]
            },
        }
    },
    [AuthenticationSchemaIds.ACCESS_TOKEN]: {
        id: AuthenticationSchemaIds.ACCESS_TOKEN,
        schema: {
            unevaluatedProperties: false,
        },
        properties: {
            access: {
                ref: CommonSchemaIds.BEARER_TOKEN,
                required: true,
                usage: [],
            },
            refresh: {
                ref: CommonSchemaIds.BEARER_TOKEN,
                required: true,
                usage: [],
            },
        }
    },
    [AuthenticationSchemaIds.GUEST]: {
        id: AuthenticationSchemaIds.GUEST,
        schema: {
            unevaluatedProperties: false,
        },
        properties: {}
    },
};
